var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('filters-renderer',{attrs:{"widgets-map":_vm.$options.widgetsMap,"prepared-filters":_vm.commonFilters,"update-multiple-values":_vm.updateMultipleValues,"update-value":_vm.updateValue,"value":_vm.value}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }